import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js'; // Your main App component
import { FirebaseProvider } from './App.js'; // Import FirebaseProvider from App.jsx
import './index.css'; // Assuming you have an index.css or equivalent

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <FirebaseProvider> {/* Wrap your App component with FirebaseProvider */}
      <App />
    </FirebaseProvider>
  </React.StrictMode>,
);